"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./index.scss");
const contexts_1 = require("@App/contexts");
const react_hook_form_1 = require("react-hook-form");
const create_rightsholder_1 = require("@Entities/schemas/rightsholder/create-rightsholder");
const zod_1 = require("@hookform/resolvers/zod");
const DropdownForm_1 = __importDefault(require("@Fields/v2/DropdownForm"));
const form_field_types_1 = require("@App/enum/form-field-types");
const Button_1 = require("@Components/Buttons/Button");
const common_1 = require("@Const/common");
const mobx_react_1 = require("mobx-react");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const ModalPortal_1 = __importDefault(require("@Components/Popups/ModalPortal"));
const RegistrationCompletePopup_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RegistrationCompletePopup"));
const RegistrationQuestionnaireHeader_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RegistrationQuestionnaire/RegistrationQuestionnaireHeader"));
const numberOfWorksOptions = [
    {
        id: 'worksOption1',
        value: 'Up to 100',
        label: 'Up to 100',
    },
    {
        id: 'worksOption2',
        value: '101 to 300',
        label: '101 to 300',
    },
    {
        id: 'worksOption3',
        value: '301 to 500',
        label: '301 to 500',
    },
    {
        id: 'worksOption4',
        value: '501 to 1,000',
        label: '501 to 1,000',
    },
    {
        id: 'worksOption5',
        value: '1,001 to 10,000',
        label: '1,001 to 10,000',
    },
    {
        id: 'worksOption6',
        value: '10,001 to 100,000',
        label: '10,001 to 100,000',
    },
    {
        id: 'worksOption7',
        value: '100,001 to 300,000',
        label: '100,001 to 300,000',
    },
    {
        id: 'worksOption8',
        value: '301,000 to 500,000',
        label: '301,000 to 500,000',
    },
    {
        id: 'worksOption9',
        value: 'Over 500,000',
        label: 'Over 500,000',
    },
];
const RegistrationQuestionnaire = () => {
    var _a, _b;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { createRightsholderStore, preloaderStore, userStore, popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const [popupIsOpen, setPopupIsOpen] = (0, react_1.useState)(false);
    const validateFormIsComplete = () => {
        const newRightsholder = createRightsholderStore.createRightsholder;
        try {
            create_rightsholder_1.createRightsholderFormSchema.parse(newRightsholder);
        }
        catch (ignore) {
            navigate(navigation_1.default.registrationRightsholder.root());
        }
    };
    const onSubmit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        preloaderStore.openTransparentPreloader(true);
        const userId = userStore.userInfo.id || '';
        const questionnaire = {
            questionAnswers: [
                {
                    userId: userId,
                    questionId: 1,
                    answer: data.question1,
                },
                {
                    userId: userId,
                    questionId: 2,
                    answer: data.question2,
                },
            ],
        };
        createRightsholderStore.setCreateRightsholderQuestionnaire(questionnaire.questionAnswers);
        if (!userStore.userInfo.isInternalUser) {
            try {
                yield createRightsholderStore.submitCreateRightsholder();
            }
            catch (e) {
                popupStore.setAlertFromError(e);
                navigate(navigation_1.default.registrationRightsholder.form());
            }
            finally {
                userStore.setUserViewedWelcomePopup();
                preloaderStore.openTransparentPreloader(false);
            }
            setPopupIsOpen(true);
        }
    });
    const closePopup = () => {
        navigate(navigation_1.default.profile.rightsHolders());
        setPopupIsOpen(false);
    };
    (0, react_1.useEffect)(() => {
        validateFormIsComplete();
    }, []);
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        delayError: 750,
        resolver: (0, zod_1.zodResolver)(create_rightsholder_1.createRightsholderQuestionnaireFormSchema),
    });
    const questions = createRightsholderStore.questions;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(RegistrationQuestionnaireHeader_1.default, null),
        react_1.default.createElement("div", { className: "registration-questionnaire-wrapper" },
            react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
                react_1.default.createElement("form", { onSubmit: methods.handleSubmit(onSubmit) },
                    (questions === null || questions === void 0 ? void 0 : questions.length) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("p", null, (_a = questions[0]) === null || _a === void 0 ? void 0 : _a.question),
                        react_1.default.createElement(DropdownForm_1.default, { options: numberOfWorksOptions, name: 'question1', label: '', type: form_field_types_1.FormFieldTypes.DROPDOWN, className: "register-dropdown" }),
                        react_1.default.createElement("p", null, (_b = questions[1]) === null || _b === void 0 ? void 0 : _b.question),
                        react_1.default.createElement(DropdownForm_1.default, { options: numberOfWorksOptions, name: 'question2', label: '', type: form_field_types_1.FormFieldTypes.DROPDOWN, className: "register-dropdown" }))),
                    react_1.default.createElement("div", { className: 'registration-questionnaire-button-container' },
                        react_1.default.createElement(Button_1.Button, { type: 'secondary', icon: common_1.ICONS.arrow_back, mainColor: true, reverseIconPosition: true, className: 'back-button', onClick: () => {
                                navigate(navigation_1.default.registrationRightsholder.form());
                            } }, "Back"),
                        react_1.default.createElement(Button_1.Button, { type: 'primary', icon: common_1.ICONS.arrow_forward, mainColor: true, submitType: 'submit', disabled: userStore.userInfo.isInternalUser, className: 'submit-button' }, "Submit")))),
            react_1.default.createElement(ModalPortal_1.default, { isOpen: popupIsOpen },
                react_1.default.createElement(RegistrationCompletePopup_1.default, { closePopup: closePopup })))));
};
exports.default = (0, mobx_react_1.observer)(RegistrationQuestionnaire);
